/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as o from '../output/output_ast';

const CORE = '@angular/core';

export class Identifiers {
  /* Methods */
  static NEW_METHOD = 'factory';
  static TRANSFORM_METHOD = 'transform';
  static PATCH_DEPS = 'patchedDeps';

  /* Instructions */
  static namespaceHTML: o.ExternalReference = {name: 'ÉµÉµnamespaceHTML', moduleName: CORE};

  static namespaceMathML: o.ExternalReference = {name: 'ÉµÉµnamespaceMathML', moduleName: CORE};

  static namespaceSVG: o.ExternalReference = {name: 'ÉµÉµnamespaceSVG', moduleName: CORE};

  static element: o.ExternalReference = {name: 'ÉµÉµelement', moduleName: CORE};

  static elementStart: o.ExternalReference = {name: 'ÉµÉµelementStart', moduleName: CORE};

  static elementEnd: o.ExternalReference = {name: 'ÉµÉµelementEnd', moduleName: CORE};

  static elementProperty: o.ExternalReference = {name: 'ÉµÉµelementProperty', moduleName: CORE};

  static select: o.ExternalReference = {name: 'ÉµÉµselect', moduleName: CORE};

  static componentHostSyntheticProperty:
      o.ExternalReference = {name: 'ÉµÉµcomponentHostSyntheticProperty', moduleName: CORE};

  static componentHostSyntheticListener:
      o.ExternalReference = {name: 'ÉµÉµcomponentHostSyntheticListener', moduleName: CORE};

  static elementAttribute: o.ExternalReference = {name: 'ÉµÉµelementAttribute', moduleName: CORE};

  static elementClassProp: o.ExternalReference = {name: 'ÉµÉµelementClassProp', moduleName: CORE};

  static elementContainerStart:
      o.ExternalReference = {name: 'ÉµÉµelementContainerStart', moduleName: CORE};

  static elementContainerEnd:
      o.ExternalReference = {name: 'ÉµÉµelementContainerEnd', moduleName: CORE};

  static elementStyling: o.ExternalReference = {name: 'ÉµÉµelementStyling', moduleName: CORE};

  static elementStylingMap: o.ExternalReference = {name: 'ÉµÉµelementStylingMap', moduleName: CORE};

  static elementStyleProp: o.ExternalReference = {name: 'ÉµÉµelementStyleProp', moduleName: CORE};

  static elementStylingApply:
      o.ExternalReference = {name: 'ÉµÉµelementStylingApply', moduleName: CORE};

  static elementHostAttrs: o.ExternalReference = {name: 'ÉµÉµelementHostAttrs', moduleName: CORE};

  static elementHostStyling: o.ExternalReference = {name: 'ÉµÉµelementHostStyling', moduleName: CORE};

  static elementHostStylingMap:
      o.ExternalReference = {name: 'ÉµÉµelementHostStylingMap', moduleName: CORE};

  static elementHostStyleProp:
      o.ExternalReference = {name: 'ÉµÉµelementHostStyleProp', moduleName: CORE};

  static elementHostClassProp:
      o.ExternalReference = {name: 'ÉµÉµelementHostClassProp', moduleName: CORE};

  static elementHostStylingApply:
      o.ExternalReference = {name: 'ÉµÉµelementHostStylingApply', moduleName: CORE};

  static containerCreate: o.ExternalReference = {name: 'ÉµÉµcontainer', moduleName: CORE};

  static nextContext: o.ExternalReference = {name: 'ÉµÉµnextContext', moduleName: CORE};

  static templateCreate: o.ExternalReference = {name: 'ÉµÉµtemplate', moduleName: CORE};

  static text: o.ExternalReference = {name: 'ÉµÉµtext', moduleName: CORE};

  static textBinding: o.ExternalReference = {name: 'ÉµÉµtextBinding', moduleName: CORE};

  static bind: o.ExternalReference = {name: 'ÉµÉµbind', moduleName: CORE};

  static enableBindings: o.ExternalReference = {name: 'ÉµÉµenableBindings', moduleName: CORE};

  static disableBindings: o.ExternalReference = {name: 'ÉµÉµdisableBindings', moduleName: CORE};

  static allocHostVars: o.ExternalReference = {name: 'ÉµÉµallocHostVars', moduleName: CORE};

  static getCurrentView: o.ExternalReference = {name: 'ÉµÉµgetCurrentView', moduleName: CORE};

  static restoreView: o.ExternalReference = {name: 'ÉµÉµrestoreView', moduleName: CORE};

  static interpolation1: o.ExternalReference = {name: 'ÉµÉµinterpolation1', moduleName: CORE};
  static interpolation2: o.ExternalReference = {name: 'ÉµÉµinterpolation2', moduleName: CORE};
  static interpolation3: o.ExternalReference = {name: 'ÉµÉµinterpolation3', moduleName: CORE};
  static interpolation4: o.ExternalReference = {name: 'ÉµÉµinterpolation4', moduleName: CORE};
  static interpolation5: o.ExternalReference = {name: 'ÉµÉµinterpolation5', moduleName: CORE};
  static interpolation6: o.ExternalReference = {name: 'ÉµÉµinterpolation6', moduleName: CORE};
  static interpolation7: o.ExternalReference = {name: 'ÉµÉµinterpolation7', moduleName: CORE};
  static interpolation8: o.ExternalReference = {name: 'ÉµÉµinterpolation8', moduleName: CORE};
  static interpolationV: o.ExternalReference = {name: 'ÉµÉµinterpolationV', moduleName: CORE};

  static pureFunction0: o.ExternalReference = {name: 'ÉµÉµpureFunction0', moduleName: CORE};
  static pureFunction1: o.ExternalReference = {name: 'ÉµÉµpureFunction1', moduleName: CORE};
  static pureFunction2: o.ExternalReference = {name: 'ÉµÉµpureFunction2', moduleName: CORE};
  static pureFunction3: o.ExternalReference = {name: 'ÉµÉµpureFunction3', moduleName: CORE};
  static pureFunction4: o.ExternalReference = {name: 'ÉµÉµpureFunction4', moduleName: CORE};
  static pureFunction5: o.ExternalReference = {name: 'ÉµÉµpureFunction5', moduleName: CORE};
  static pureFunction6: o.ExternalReference = {name: 'ÉµÉµpureFunction6', moduleName: CORE};
  static pureFunction7: o.ExternalReference = {name: 'ÉµÉµpureFunction7', moduleName: CORE};
  static pureFunction8: o.ExternalReference = {name: 'ÉµÉµpureFunction8', moduleName: CORE};
  static pureFunctionV: o.ExternalReference = {name: 'ÉµÉµpureFunctionV', moduleName: CORE};

  static pipeBind1: o.ExternalReference = {name: 'ÉµÉµpipeBind1', moduleName: CORE};
  static pipeBind2: o.ExternalReference = {name: 'ÉµÉµpipeBind2', moduleName: CORE};
  static pipeBind3: o.ExternalReference = {name: 'ÉµÉµpipeBind3', moduleName: CORE};
  static pipeBind4: o.ExternalReference = {name: 'ÉµÉµpipeBind4', moduleName: CORE};
  static pipeBindV: o.ExternalReference = {name: 'ÉµÉµpipeBindV', moduleName: CORE};

  static property: o.ExternalReference = {name: 'ÉµÉµproperty', moduleName: CORE};

  static propertyInterpolate:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate', moduleName: CORE};
  static propertyInterpolate1:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate1', moduleName: CORE};
  static propertyInterpolate2:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate2', moduleName: CORE};
  static propertyInterpolate3:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate3', moduleName: CORE};
  static propertyInterpolate4:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate4', moduleName: CORE};
  static propertyInterpolate5:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate5', moduleName: CORE};
  static propertyInterpolate6:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate6', moduleName: CORE};
  static propertyInterpolate7:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate7', moduleName: CORE};
  static propertyInterpolate8:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolate8', moduleName: CORE};
  static propertyInterpolateV:
      o.ExternalReference = {name: 'ÉµÉµpropertyInterpolateV', moduleName: CORE};

  static i18n: o.ExternalReference = {name: 'ÉµÉµi18n', moduleName: CORE};
  static i18nAttributes: o.ExternalReference = {name: 'ÉµÉµi18nAttributes', moduleName: CORE};
  static i18nExp: o.ExternalReference = {name: 'ÉµÉµi18nExp', moduleName: CORE};
  static i18nStart: o.ExternalReference = {name: 'ÉµÉµi18nStart', moduleName: CORE};
  static i18nEnd: o.ExternalReference = {name: 'ÉµÉµi18nEnd', moduleName: CORE};
  static i18nApply: o.ExternalReference = {name: 'ÉµÉµi18nApply', moduleName: CORE};
  static i18nPostprocess: o.ExternalReference = {name: 'ÉµÉµi18nPostprocess', moduleName: CORE};
  static i18nLocalize: o.ExternalReference = {name: 'ÉµÉµi18nLocalize', moduleName: CORE};

  static load: o.ExternalReference = {name: 'ÉµÉµload', moduleName: CORE};

  static pipe: o.ExternalReference = {name: 'ÉµÉµpipe', moduleName: CORE};

  static projection: o.ExternalReference = {name: 'ÉµÉµprojection', moduleName: CORE};
  static projectionDef: o.ExternalReference = {name: 'ÉµÉµprojectionDef', moduleName: CORE};

  static reference: o.ExternalReference = {name: 'ÉµÉµreference', moduleName: CORE};

  static inject: o.ExternalReference = {name: 'ÉµÉµinject', moduleName: CORE};

  static injectAttribute: o.ExternalReference = {name: 'ÉµÉµinjectAttribute', moduleName: CORE};

  static directiveInject: o.ExternalReference = {name: 'ÉµÉµdirectiveInject', moduleName: CORE};

  static templateRefExtractor:
      o.ExternalReference = {name: 'ÉµÉµtemplateRefExtractor', moduleName: CORE};

  static resolveWindow: o.ExternalReference = {name: 'ÉµÉµresolveWindow', moduleName: CORE};
  static resolveDocument: o.ExternalReference = {name: 'ÉµÉµresolveDocument', moduleName: CORE};
  static resolveBody: o.ExternalReference = {name: 'ÉµÉµresolveBody', moduleName: CORE};

  static defineBase: o.ExternalReference = {name: 'ÉµÉµdefineBase', moduleName: CORE};

  static BaseDef: o.ExternalReference = {
    name: 'ÉµÉµBaseDef',
    moduleName: CORE,
  };

  static defineComponent: o.ExternalReference = {name: 'ÉµÉµdefineComponent', moduleName: CORE};

  static setComponentScope: o.ExternalReference = {name: 'ÉµÉµsetComponentScope', moduleName: CORE};

  static ComponentDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµComponentDefWithMeta',
    moduleName: CORE,
  };

  static defineDirective: o.ExternalReference = {
    name: 'ÉµÉµdefineDirective',
    moduleName: CORE,
  };

  static DirectiveDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµDirectiveDefWithMeta',
    moduleName: CORE,
  };

  static InjectorDef: o.ExternalReference = {
    name: 'ÉµÉµInjectorDef',
    moduleName: CORE,
  };

  static defineInjector: o.ExternalReference = {
    name: 'ÉµÉµdefineInjector',
    moduleName: CORE,
  };

  static NgModuleDefWithMeta: o.ExternalReference = {
    name: 'ÉµÉµNgModuleDefWithMeta',
    moduleName: CORE,
  };

  static defineNgModule: o.ExternalReference = {name: 'ÉµÉµdefineNgModule', moduleName: CORE};
  static setNgModuleScope: o.ExternalReference = {name: 'ÉµÉµsetNgModuleScope', moduleName: CORE};

  static PipeDefWithMeta: o.ExternalReference = {name: 'ÉµÉµPipeDefWithMeta', moduleName: CORE};

  static definePipe: o.ExternalReference = {name: 'ÉµÉµdefinePipe', moduleName: CORE};

  static queryRefresh: o.ExternalReference = {name: 'ÉµÉµqueryRefresh', moduleName: CORE};
  static viewQuery: o.ExternalReference = {name: 'ÉµÉµviewQuery', moduleName: CORE};
  static staticViewQuery: o.ExternalReference = {name: 'ÉµÉµstaticViewQuery', moduleName: CORE};
  static staticContentQuery: o.ExternalReference = {name: 'ÉµÉµstaticContentQuery', moduleName: CORE};
  static loadViewQuery: o.ExternalReference = {name: 'ÉµÉµloadViewQuery', moduleName: CORE};
  static contentQuery: o.ExternalReference = {name: 'ÉµÉµcontentQuery', moduleName: CORE};
  static loadContentQuery: o.ExternalReference = {name: 'ÉµÉµloadContentQuery', moduleName: CORE};

  static NgOnChangesFeature: o.ExternalReference = {name: 'ÉµÉµNgOnChangesFeature', moduleName: CORE};

  static InheritDefinitionFeature:
      o.ExternalReference = {name: 'ÉµÉµInheritDefinitionFeature', moduleName: CORE};

  static ProvidersFeature: o.ExternalReference = {name: 'ÉµÉµProvidersFeature', moduleName: CORE};

  static listener: o.ExternalReference = {name: 'ÉµÉµlistener', moduleName: CORE};

  static getFactoryOf: o.ExternalReference = {
    name: 'ÉµÉµgetFactoryOf',
    moduleName: CORE,
  };

  static getInheritedFactory: o.ExternalReference = {
    name: 'ÉµÉµgetInheritedFactory',
    moduleName: CORE,
  };

  static registerNgModuleType:
      o.ExternalReference = {name: 'ÉµregisterNgModuleType', moduleName: CORE};

  // sanitization-related functions
  static sanitizeHtml: o.ExternalReference = {name: 'ÉµÉµsanitizeHtml', moduleName: CORE};
  static sanitizeStyle: o.ExternalReference = {name: 'ÉµÉµsanitizeStyle', moduleName: CORE};
  static defaultStyleSanitizer:
      o.ExternalReference = {name: 'ÉµÉµdefaultStyleSanitizer', moduleName: CORE};
  static sanitizeResourceUrl:
      o.ExternalReference = {name: 'ÉµÉµsanitizeResourceUrl', moduleName: CORE};
  static sanitizeScript: o.ExternalReference = {name: 'ÉµÉµsanitizeScript', moduleName: CORE};
  static sanitizeUrl: o.ExternalReference = {name: 'ÉµÉµsanitizeUrl', moduleName: CORE};
  static sanitizeUrlOrResourceUrl:
      o.ExternalReference = {name: 'ÉµÉµsanitizeUrlOrResourceUrl', moduleName: CORE};
}
